import { icons, type LucideIcon } from "lucide-react";

/** Every Lucide icon by its name without dashes and in lower case ("map-pin" is found as "mappin"); "home" is kept for entries saved before the whole library was offered. */
export const SITE_ICON_INDEX: Record<string, LucideIcon> = {
  ...Object.fromEntries(Object.entries(icons).map(([key, icon]) => [key.toLowerCase(), icon])),
  home: icons.House,
};
